/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { RESOURCE } from 'apmui/resource/ResourceType';
import { WebtopResourceModel } from 'apmui/resource/WebtopResourceModel';
import { IResourceProps } from '../ResourceLoader';

class AppTunnelModel extends WebtopResourceModel {
    // static
    static readonly propNames = [...WebtopResourceModel.propNames];
    // instance
    type: RESOURCE.APP_TUNNEL = RESOURCE.APP_TUNNEL;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);
        this.undefinedIconToDefault();
    }

    getPropNames(): string[] {
        return AppTunnelModel.propNames;
    }
}

export { AppTunnelModel as default, AppTunnelModel };
